import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import ApprovedMedia from './approved-media-model'
import {
  CreateApprovedMediaAsync,
  DeleteApprovedMediaAsync,
  LoadApprovedMediasAsync,
} from './approvedMedia-thunk'
const initialState: approvedMediaSliceState = {
  approvedMedia: [],
  selected_approvedMedia: '',
  is_loading_approvedMedia: false,
  is_creating_approvedMedia: false,
  is_deleting_approvedMedia: false,
}
export interface approvedMediaSliceState {
  approvedMedia: ApprovedMedia[]
  selected_approvedMedia?: string
  is_loading_approvedMedia: boolean
  is_creating_approvedMedia: boolean
  is_deleting_approvedMedia: boolean
}
export const approvedMediaSlice = createSlice({
  name: 'approvedMedia',
  initialState,
  reducers: {
    setSelectedapprovedMedia: (state, action) => {
      state.selected_approvedMedia = action.payload
    },
    clearStateapprovedMedia: (state) => {
      state.approvedMedia = []
      state.is_loading_approvedMedia = false
      state.is_creating_approvedMedia = false
      state.is_deleting_approvedMedia = false
    },
    mergeapprovedMedia: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_approvedMedia = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.approvedMedia = merge(state.approvedMedia, payload) as any
        }
      }
    },

    add_approvedMedia: (state, action) => {
      if (action.payload) {
        state.approvedMedia = [...state.approvedMedia, action.payload]
      }
    },
    set_approvedMedia: (state, action) => {
      let { key, value, id } = action.payload
      state.approvedMedia = state.approvedMedia.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadApprovedMediasAsync.pending, (state) => {
      state.is_loading_approvedMedia = true
    })
    builder.addCase(LoadApprovedMediasAsync.fulfilled, (state, action) => {
      state.is_loading_approvedMedia = false
      if (action.payload) {
        state.approvedMedia = action.payload
      }
    })
    builder.addCase(LoadApprovedMediasAsync.rejected, (state) => {
      state.is_loading_approvedMedia = false
    })
    builder.addCase(CreateApprovedMediaAsync.pending, (state) => {
      state.is_creating_approvedMedia = true
    })
    builder.addCase(CreateApprovedMediaAsync.fulfilled, (state) => {
      state.is_creating_approvedMedia = false
    })
    builder.addCase(CreateApprovedMediaAsync.rejected, (state) => {
      state.is_creating_approvedMedia = false
    })
    builder.addCase(DeleteApprovedMediaAsync.pending, (state) => {
      state.is_deleting_approvedMedia = true
    })
    builder.addCase(DeleteApprovedMediaAsync.fulfilled, (state, action) => {
      state.is_deleting_approvedMedia = false
      if (state.approvedMedia) {
        state.approvedMedia = state.approvedMedia.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteApprovedMediaAsync.rejected, (state) => {
      state.is_deleting_approvedMedia = false
    })

    builder.addCase(
      autoThunks.get_approved_media_by_media_id.pending,
      (state) => {
        state.is_loading_approvedMedia = true
      },
    )
    builder.addCase(
      autoThunks.get_approved_media_by_media_id.fulfilled,
      (state, action) => {
        state.is_loading_approvedMedia = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_approved_media_by_media_id.rejected,
      (state) => {
        state.is_loading_approvedMedia = false
      },
    )

    builder.addCase(autoThunks.get_approved_media_by_owner.pending, (state) => {
      state.is_loading_approvedMedia = true
    })
    builder.addCase(
      autoThunks.get_approved_media_by_owner.fulfilled,
      (state, action) => {
        state.is_loading_approvedMedia = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_approved_media_by_owner.rejected,
      (state) => {
        state.is_loading_approvedMedia = false
      },
    )

    builder.addCase(autoThunks.load_approved_media.pending, (state) => {
      state.is_loading_approvedMedia = true
    })
    builder.addCase(
      autoThunks.load_approved_media.fulfilled,
      (state, action) => {
        state.is_loading_approvedMedia = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.load_approved_media.rejected, (state) => {
      state.is_loading_approvedMedia = false
    })

    builder.addCase(
      autoThunks.get_approved_media_by_media_id_watch.pending,
      (state) => {
        state.is_loading_approvedMedia = true
      },
    )
    builder.addCase(
      autoThunks.get_approved_media_by_media_id_watch.fulfilled,
      (state, action) => {
        state.is_loading_approvedMedia = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_approved_media_by_media_id_watch.rejected,
      (state) => {
        state.is_loading_approvedMedia = false
      },
    )

    builder.addCase(autoThunks.set_hidden_approvedMedia.pending, (state) => {
      state.is_loading_approvedMedia = true
    })
    builder.addCase(
      autoThunks.set_hidden_approvedMedia.fulfilled,
      (state, action) => {
        state.is_loading_approvedMedia = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.set_hidden_approvedMedia.rejected, (state) => {
      state.is_loading_approvedMedia = false
    })

    builder.addCase(autoThunks.fetch_all_approvedMedia.pending, (state) => {
      state.is_loading_approvedMedia = true
    })
    builder.addCase(
      autoThunks.fetch_all_approvedMedia.fulfilled,
      (state, action) => {
        state.is_loading_approvedMedia = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.fetch_all_approvedMedia.rejected, (state) => {
      state.is_loading_approvedMedia = false
    })

    builder.addCase(autoThunks.fetch_approved_media_by_id.pending, (state) => {
      state.is_loading_approvedMedia = true
    })
    builder.addCase(
      autoThunks.fetch_approved_media_by_id.fulfilled,
      (state, action) => {
        state.is_loading_approvedMedia = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.fetch_approved_media_by_id.rejected, (state) => {
      state.is_loading_approvedMedia = false
    })

    builder.addCase(autoThunks.get_next_approved_medias.pending, (state) => {
      state.is_loading_approvedMedia = true
    })
    builder.addCase(
      autoThunks.get_next_approved_medias.fulfilled,
      (state, action) => {
        state.is_loading_approvedMedia = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_next_approved_medias.rejected, (state) => {
      state.is_loading_approvedMedia = false
    })
  },
})

function handleResult(action: any, state: approvedMediaSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_approvedMedia = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.approvedMedia = merge(state.approvedMedia, payload) as any
    }
  }
}

export const {
  clearStateapprovedMedia,
  setSelectedapprovedMedia,
  set_approvedMedia,
  mergeapprovedMedia,
  add_approvedMedia,
} = approvedMediaSlice.actions

export const get_approvedMedia =
  (id?: string) =>
  (state: {
    approvedMedia: {
      approvedMedia: ApprovedMedia[]
    }
  }): ApprovedMedia | null => {
    let temp = state?.approvedMedia?.approvedMedia?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.approvedMedia?.approvedMedia[0] || null
  }
export const get_selected_approvedMedia = (state: {
  approvedMedia: approvedMediaSliceState
}): ApprovedMedia | null => {
  let id = state?.approvedMedia?.selected_approvedMedia
  let temp = state?.approvedMedia?.approvedMedia?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_approvedMedia = (state: {
  approvedMedia: {
    approvedMedia: ApprovedMedia[]
  }
}): ApprovedMedia[] => {
  let temp = state?.approvedMedia?.approvedMedia
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_approvedMedia_busy = (state: {
  approvedMedia: approvedMediaSliceState
}) => {
  return (
    state?.approvedMedia.is_deleting_approvedMedia ||
    state?.approvedMedia.is_loading_approvedMedia ||
    state?.approvedMedia.is_creating_approvedMedia
  )
}
export const is_deleting_approvedMedia_busy = (state: {
  approvedMedia: approvedMediaSliceState
}) => {
  return state?.approvedMedia.is_deleting_approvedMedia
}
export const is_loading_approvedMedia_busy = (state: {
  approvedMedia: approvedMediaSliceState
}) => {
  return state?.approvedMedia.is_loading_approvedMedia
}
export const is_creating_approvedMedia_busy = (state: {
  approvedMedia: approvedMediaSliceState
}) => {
  return state?.approvedMedia.is_creating_approvedMedia
}

export default approvedMediaSlice.reducer
